import {
  Box,
  Button,
  Drawer,
  Link,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  IconButton,
  Popper,
  Tooltip
} from "@mui/material";
import {
  Audiotrack,
  AutoFixHigh,
  Close,
  Settings,
  Share,
  SportsScore,
  Toll,
  Savings,
  Logout,
  Star,
  StarOutline,
  GridOn,
  ViewDay,
  Attribution,
  People,
  Home,
  DarkMode,
  LightMode
} from "@mui/icons-material";
import React, { useContext, useRef, useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useLayoutContext } from "../../contexts/LayoutContext";

import AuthBox from "../auth-box";
import { handleLogout } from "../../utils/auth-provider";
import { APP_ROUTES } from "../../constants/routes";
import AppContext from "../../utils/app-context";
import Breadcrumbs from "./Breadcrumbs";
import EditableField from "../editable-field";
import ForkProject from "../fork";
import ShareDialog from "../dialogs/share";
import StoryAudio from "../dialogs/audio";
import logo from "../../images/logo.svg";
import logoMobile from "../../images/logo-mobile.svg";
import theme from "../../styles/theme";
import useMediaQuery from '@mui/material/useMediaQuery';
import { nothing } from "immer";
import DropUpload from "../drop-upload";
import { AuthContext } from "../../utils/auth-provider";
import LoginDialog from "../dialogs/login";
import ProjectCreditsDialog from "../dialogs/project-credits";
import ManageMembersDialog from "../dialogs/manage-members";
import { isAtLeastMember, canManageMembers } from "../../utils/permissions";

const subnavStyles = {
  flexDirection: "row",
  maxWidth: "100%",
  display: "flex",
  flexDirection: "row",
  position: "relative",
  alignItems: "center",
  justifyContent: "space-between",
  borderBottom: "1px solid var(--border-subtle)",
  backgroundColor: "var(--bg-surface)",
  padding: ".5em 3em .5em calc(3em - 6px)",
  //padding:"0 20px", 
  "&.title-head": {
    display: "block",
  },
  //height:'calc(110px - 1.5em)',
  ".title": {
    paddingRight: "25px",
    overflow: "hidden",
    flex: "none",
    //width: "calc(100% / 3)"
  },
  "h1": {
    padding: "10px 0",
    height: "36px",
    display: "flex",
    alignItems: "center",
    justifyContent: "left",
  },
  ".title form": {
    width: "100%",
  },
  ".title.long h1, .title.long h1 .input__cd": {
    fontSize: "15px",
  },
  ".text": {
    flex: "3 1 0",
    maxWidth: "80%",
    paddingRight: "25px",
    color: "var(--text-secondary)",
    overflowY: "scroll"
  },
  /*"div": {
    flex: "1 2 0",
  },*/
  "ul": {
    minHeight: "36px",
    display: "flex",
    flex: "1 1 auto",
    "a": {
      lineHeight: "28px",
    },
  },
  [theme.breakpoints.down("md")]: {
    padding: ".5em 1.5em .5em 1em",
    //    padding:"0 10px", 
    //height:'calc(105px - .5em)',
    //flexDirection: "column",
    // alignItems: "flex-start",
    ".title": {
      paddingLeft: "calc(.5em - 6px)",
      paddingRight: "10px",
      h1: {
        fontSize: "18px",
        lineHeight: "28px",
      },
    },
    ul: {
      //paddingLeft: ".5em",
    },
    ".text": {
      fontSize: "12px",
    },
    ".filmed": {
      display: "none",
    },
  },
};
const headnavStyles = {
  padding: "1em 3em",
  //height:'calc(110px - 2em)',
  backgroundColor: "var(--bg-header)",
  borderBottom: "1px solid var(--border-subtle)",
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  position: "relative",
  "div, a": {
    flex: "1 1 0",
  },
  button: {
    padding: 0, //"0 10px",
  },
  IconButton: {
    transition: "all .5s ease-in-out",
    padding: "0px",
    "&:hover": {
      background: "rgba(0, 0, 0, 0.15)",
      transition: "all .5s ease-in-out",
    },
    "&.account": {
      marginLeft: "10px"
    }
  },
  "button.account": {
    padding: 0,
  },
  [theme.breakpoints.down("md")]: {
    padding: ".5em 1.5em",
    //height:'calc(105px - .5em)',
    ".logo img": {
      width: "150px",
    },
    button: {
      //padding: "0 5px",
    },
    "button.account": {
      padding: 0,
    }
  },
  [theme.breakpoints.down("sm")]: {
    padding: ".5em",
    ".logo img": {
      width: "100px",
    },
  },
};

const closeStyles = {
  position: "absolute",
  right: "2em",
  top: "1em",
  cursor: "pointer",
  color: "var(--text-secondary)",
  background: "transparent",
  "&:hover": {
    color: "var(--text-primary)",
  },
  [theme.breakpoints.down("md")]: {
    right: "1em",
    top: ".5em",
  },
};

const sideMenuStyles = {
  backgroundColor: "#1F2127",
  "> div": {
    background: "#1F2127",
    borderLeft: "1px solid var(--border-subtle)",
    padding: "1em",
    minWidth: "200px",
  },
  ".close": {
    marginBottom: "2em",
    textDecoration: "none !important",
    "&:hover": {
      textDecoration: "none !important",
    },
  },
  a: {
    color: "#ffffff",
    display: "flex",
    textAlign: "left",
    textDecoration: "none !important",
    "&:hover": {
      textDecoration: "underline !important",
    },
  },
  span: {
    padding: 0,
    display: "block",
    margin: "0 .5em 1em 0",
  },
  svg: {
    display: "block",
    marginRight: ".5em",
  },
  input: {
    color: theme.palette.primary.main,
    padding: 0,
  },
};


const Headbar = (props) => {
  const { state, dispatch } = useContext(AppContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [fixed, setFixed] = useState(false);
  const [sidebarVisible, setSidebarVisible] = useState(state.app.sidebarOpen || false);
  const [movable, setMovable] = useState(false);
  const [showShare, setShowShare] = useState(false);
  const [showAccount, setShowAccount] = useState(false);
  const [timerAlert, setTimerAlert] = useState(false);
  const [timerNow, setTimerNow] = useState(null);
  const timerRef = useRef(null);
  const [loginOpen, setLoginOpen] = useState(false);
  const [isDeleted, setIsDeleted] = useState(false);
  const [importFormOpen, setImportFormOpen] = React.useState(false)
  const [showAudio, setShowAudio] = useState(false);
  const [isStarred, setIsStarred] = useState(false);
  const [showProjectCredits, setShowProjectCredits] = useState(false);
  const [showManageMembers, setShowManageMembers] = useState(false);
  const userRole = state.app.userProjectRole;
  const storyRoute = Boolean(location.pathname?.startsWith('/p/'));
  const { themeMode, toggleThemeMode } = useLayoutContext();

  const story = state.stories.activeStory;
  const titleRoute = location.pathname === APP_ROUTES.STORY_BOARDS || location.pathname === APP_ROUTES.PREVIEW;

  const timerStyles = {
    color: timerAlert ? "red" : "white",
    padding: "5px 10px",
    maxWidth: "fit-content",
    textAlign: "center",
    alignContent: "center",
    border: "1px solid " + (timerAlert ? "red" : "white"),
  };

  useEffect(() => {
    if (location.pathname === "/storyboards") {
      setIsDeleted(false);
    } else {
      if (story && story.deleted_at) {
        setIsDeleted(true);
      } else {
        setIsDeleted(false);
      }
    }
  }, [story, location.pathname]);

  useEffect(() => {
    setSidebarVisible(state.app.sidebarOpen);
  }, [state.app.sidebarOpen]);

  useEffect(() => {
    setIsStarred(state.stories.starredStories.find((story) => story.portal_id == portal_id) ? true : false);
  }, [state.stories.starredStories, state.stories.activeStory])

  const extractCurrentId = (pathname) => {
    const parts = pathname.split('/');
    if (pathname.includes('/details/')) {

      return parts[parts.length - 2];
    }
    if (pathname.includes('/p/')) {

      const match = pathname.length && pathname.match(/^\/p\/([^/]+)/);
      return match ? match[1] : null;
      // return parts[parts.length - 1]; 
    }
    return null;
  };

  const currentId = extractCurrentId(location.pathname);
  const isStripPage = location.pathname.endsWith('/strip');
  const toggleShare = () => setShowShare((p) => !p);
  const toggleShowAudio = () => setShowAudio((p) => !p);

  const isAdmin = props.admin || false;

  const medScreen = (useMediaQuery(theme.breakpoints.down("md"))) ? true : false
  const smallScreen = (useMediaQuery(theme.breakpoints.down("sm"))) ? true : false

  const logoAlign = state.app.isMobileSize ? "left" : "center";

  const title = props.title ? props.title : story.title ? story.title : "Untitled";
  const shotId = props.shotId ? props.shotId : null;
  const breadcrumbs = props.breadcrumbs == false ? false : true;
  const timer = props.timer == false ? false : state.app.settings.isCompetition ? true : false;
  const shareActive = props.share == true ? true : false;
  const forkActive = props.fork == true ? true : false;
  const { settings, filmed, btns, close, text } = props;
  const output = [];
  const showTimer = props.timer != undefined ? props.timer : true;
  const starredActive = props.starred === true;
  const portal_id = state.stories.activeStory?.portal_id || state.app.portal.id;
  const isLoggedIn = state.userData && Object.keys(state.userData).length != 0 ? true : false
  const editableTitle = props.editableTitle || false;
  const logout = () => { handleLogout(state.userData); }
  const isOwner = state.app.userIsStoryOwner;

  const handleToggleStar = () => {
    const portal_id = state.stories.activeStory?.portal_id || state.app.portal.id;
    const isLoggedIn = Object.keys(state.userData).length != 0 ? true : false
    if (!isLoggedIn) setLoginOpen(true)
    else {
      dispatch({
        type: "TOGGLE_STORY_STAR",
        payload: { isStarred: isStarred, portal_id: portal_id }
      });
      setIsStarred(!isStarred);
    }
  }

  const handleClose = () => {
    setLoginOpen(false);
  };

  const importDialog =
    <Dialog id="import"
      onClose={() => setImportFormOpen(false)}
      open={importFormOpen}
    >
      <DialogTitle>Auto Storyboard</DialogTitle>
      <DialogContent>
        <Box>
          <Box variant="p">
            Every scene from the first 60 seconds of a video will become a panel in your storyboard.
          </Box>

          {/*<DropzoneArea
            showPreviews={true}
            showPreviewsInDropzone={false}
            useChipsForPreview
            previewGridProps={{container: { spacing: 1, direction: 'row' }}}
            previewChipProps={{classes: { root: classes.previewChip } }}
            previewText="Selected files"
          />*/}
          <Box className="app_container">
            <DropUpload maxFiles={1} type="story-import" portalId={state.stories.activeStory?.portal_id} view="upload" mediaRestrict={["video"]} dropFunc={() => setImportFormOpen(false)} />
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        {/*<Box onClick={() => setImportFormOpen(false)}>Invalid URL</Box>* }
        <Button variant='outlined' onClick={() => setImportFormOpen(false)}>
          Close
        </Button>
        { /*urlValid && 
          <Button
            labelPosition='right'
            icon='checkmark'
            onClick={importStoryboard}
            positive
            variant='contained'>Create new panels</Button>
        */}
      </DialogActions>
    </Dialog>

  function share() {
    setShowShare(true);
  }

  function doShare() {
    alert("Text or email this link to let others add video:\nhttps://okapi-webdev.web.app/p/" + state.app.portal.id);
  }

  const getInitials = () => {
    if (state.userData && state.userData.name && state.userData.email) {
      const name = state.userData.name.split(' ')
      if (name.length >= 2) return name[0].charAt(0).toUpperCase() + name[name.length - 1].charAt(0).toUpperCase();
      else if (name.length == 1) return name[0].charAt(0).toUpperCase();
      else return state.userData.email.charAt(0).toUpperCase();
    }
    return ""
  }

  const toggleCompetition = () => {
    const payload = { isCompetition: story.isCompetition == undefined ? true : !story.isCompetition };
    dispatch({ type: "TOGGLE_STORY_COMPETITION", payload: payload });
  };

  const timerInt = () => {
    const interval = setInterval(() => {
      setTimerNow(Date.now());
    }, 1000);
    timerRef.current = interval;
  };
  let timerSeconds;
  let timerDisplay = null;
  let minutes = 0;
  let seconds = 0;
  if (!timerNow) setTimerNow(Date.now());
  if (story.isCompetition) {
    let timerSeconds = 1800;
    if (story.timerStart != undefined && story.timerStart != null && !timerRef.current) {
      timerInt();
    }
    if (story.timerStart != undefined && story.timerStart != null && timerNow != null) {
      timerSeconds = 1800 - ((timerNow - story.timerStart) / 1000).toFixed(0);
      if (timerSeconds > 1800) timerSeconds = 1800;
    }
    if (timerSeconds <= 0) {
      if (timerAlert != true) setTimerAlert(true);
      timerDisplay = "0:00";
    } else {
      if (timerSeconds < 300 && timerAlert != true) setTimerAlert(true);
      else if (timerSeconds > 300 && timerAlert == true) setTimerAlert(false);
      minutes = Math.floor(timerSeconds / 60);
      seconds = timerSeconds - minutes * 60;
      timerDisplay = minutes.toString() + ":" + (seconds < 10 ? "0" + seconds : seconds.toFixed(0).toString());
    }
  }

  function open_sidebar() {
    setSidebarVisible(true);
  }

  function close_sidebar() {
    setSidebarVisible(false);
  }

  function setStoryTitle(id, title) {
    const payload = { title: title };
    dispatch({ type: "UPDATE_STORY_TITLE", payload: payload });
  }

  function setShotDescription(id, text) {
    const payload = { shot_id: shotId, description: text };
    dispatch({ type: "UPDATE_STORY_SHOT_DESCRIPTION", payload: payload });
  }

  function setShotTitle(id, title) {
    const payload = { shot_id: shotId, text: title };
    dispatch({ type: "UPDATE_STORY_SHOT_TITLE", payload: payload });
  }

  /*function toggle_movable() {
    setMovable(!movable)
  }*/

  const { currentUser } = useContext(AuthContext);
  const verticalSidebar = (
    <Drawer
      /*as={Menu}
      animation='overlay'
      direction='right'
      icon='labeled'
      inverted='true'
      vertical="true"
      visible={visible}
      width='thin'*/
      variant="persistent"
      anchor="right"
      open={sidebarVisible}
      sx={sideMenuStyles}
    >
      <Link className="close" onClick={close_sidebar} sx={{ '&:hover': { cursor: 'pointer' } }}>
        <Close sx={{ color: "#ffffff" }} />
      </Link>
      <Link onClick={(e) => { close_sidebar(); navigate("/storyboards"); e.preventDefault(); }} className="credits" sx={{ display: 'flex', marginBottom: "20px", alignItems: "center", '&:hover': { cursor: 'pointer', background: "none !important" }, "&:hover p": { textDecoration: "underline" } }}>
        <Home sx={{ color: "#ffffff", marginRight: "10px" }} />
        <Typography sx={{ color: "#ffffff", fontStyle: state.userData.processingCredits ? "italic" : "normal" }}>Home</Typography>
      </Link>
      {state.app.isMobileSize && (
        <>
          <Link onClick={(e) => { close_sidebar(); navigate("/account/credits"); e.preventDefault(); }} className="credits" sx={{ display: 'flex', marginBottom: "20px", alignItems: "center", '&:hover': { cursor: 'pointer', background: "none !important" }, "&:hover p": { textDecoration: "underline" } }}>
            <Toll sx={{ color: "#ffffff", marginRight: "10px" }} />
            <Typography sx={{ color: "#ffffff", fontStyle: state.userData.processingCredits ? "italic" : "normal" }}>Credits</Typography>
          </Link>
          {storyRoute && (<Link onClick={(e) => { e.preventDefault(); e.stopPropagation(); setShowProjectCredits(true); close_sidebar(); }} title="Project Credits" className="credits" sx={{ display: 'flex', padding: "0 !important", marginBottom: "20px", alignItems: "center", '&:hover': { cursor: 'pointer', background: "none !important" }, "&:hover span": { textDecoration: "underline" } }}>
            <Savings sx={{ color: "#ffffff", marginRight: "10px" }} />
            <Typography sx={{ color: "#ffffff" }}>Fund this project</Typography>
          </Link>)}
        </>
      )}
      {Object.keys(state.userData).length && <Link href="/account" onClick={(e) => { close_sidebar(); navigate(e.target.parentNode.getAttribute('href')); e.preventDefault(); }}
        sx={{ marginBottom: "20px", "&:hover": { cursor: "pointer" } }}
      >
        <Settings sx={{ color: "#ffffff", marginRight: "10px" }} />
        <Typography sx={{ color: "#ffffff" }}>Account</Typography>
      </Link>}
      {settings && !isDeleted && state.app.userIsStoryOwner && (
        <>
          {settings.import && (
            <Link
              onClick={() => {
                close_sidebar();
                setImportFormOpen(true);
              }}
              sx={{ marginBottom: "20px", "&:hover": { cursor: "pointer" } }}
            >
              <AutoFixHigh sx={{ color: "#ffffff" }} />
              <Typography sx={{ color: "#ffffff" }}>Auto Storyboard</Typography>
            </Link>
          )}
          {settings.competition && (
            <Link
              onClick={() => {
                close_sidebar();
                toggleCompetition();
              }}
              sx={{ marginBottom: "20px", "&:hover": { cursor: "pointer" } }}
            >
              <SportsScore sx={{ color: "#ffffff" }} />
              <Typography sx={{ color: "#ffffff" }}>Toggle Competition</Typography>
            </Link>
          )}
          {state.app.userIsStoryOwner && <Link
            onClick={() => {
              close_sidebar();
              navigate(`/p/${currentId}/attr`);
            }}
            sx={{ marginBottom: "20px", "&:hover": { cursor: "pointer" } }}
          >
            <Attribution sx={{ color: "#ffffff" }} />
            <Typography sx={{ color: "#ffffff" }}>Attribution</Typography>
          </Link>}
          {canManageMembers(userRole) && (
            <Link
              onClick={() => {
                close_sidebar();
                setShowManageMembers(true);
              }}
              sx={{ marginBottom: "20px", "&:hover": { cursor: "pointer" } }}
            >
              <People sx={{ color: "#ffffff" }} />
              <Typography sx={{ color: "#ffffff" }}>Manage Members</Typography>
            </Link>
          )}
        </>
      )}
      {/* Member-accessible sidebar links (owner + member) */}
      {settings && !isDeleted && isAtLeastMember(userRole) && (
        <>
          <Link onClick={() => {
            close_sidebar();
            setShowAudio(true);
          }}
            sx={{ marginBottom: "20px", "&:hover": { cursor: "pointer" } }}
          >
            <Audiotrack sx={{ color: "#ffffff" }} />
            <Typography sx={{ color: "#ffffff" }}>Story Audio</Typography>
          </Link>
          {settings.strip && (
            <>
              {isStripPage ? (
                <Link
                  onClick={() => {
                    close_sidebar();
                    navigate(`/p/${currentId}`);
                  }}
                  sx={{ marginBottom: "20px", "&:hover": { cursor: "pointer" } }}
                >
                  <GridOn sx={{ color: "#ffffff" }} />
                  <Typography sx={{ color: "#ffffff" }}>View as board</Typography>
                </Link>
              )
                : (
                  <Link
                    onClick={() => {
                      close_sidebar();
                      navigate(`/p/${currentId}/strip`);
                    }}
                    sx={{ marginBottom: "20px", "&:hover": { cursor: "pointer" } }}
                  >
                    <ViewDay sx={{ color: "#ffffff" }} />
                    <Typography sx={{ color: "#ffffff" }}>View as Strip</Typography>
                  </Link>
                )}
            </>
          )}
        </>
      )}
      {/*state.userData.zebradmin && */<Link
        onClick={() => {
          close_sidebar();
          logout();
        }}
        sx={{ marginBottom: "20px", "&:hover": { cursor: "pointer" } }}
      >
        <Logout sx={{ color: "#ffffff" }} />
        <Typography sx={{ color: "#ffffff" }}>Logout</Typography>
      </Link>}
    </Drawer>
  );
  return (
    <>
      <Box component="header" className="headbar" onClick={close_sidebar}>
        <Box sx={headnavStyles}>
          {!state.app.isMobileSize && <Box>
            {Object.keys(state.userData).length &&
              <IconButton onClick={(e) => { navigate("/account/credits"); e.preventDefault(); }} title="Credits" className="credits" sx={{ display: 'flex', padding: "0 !important", alignItems: "center", '&:hover': { cursor: 'pointer', background: "none !important" }, "&:hover span": { textDecoration: "underline" } }}>
                <Toll sx={{ color: "#ffffff", marginRight: "10px" }} />
                {!smallScreen && <Typography variant="span" sx={{ color: "#ffffff", fontSize: "14px", fontStyle: state.userData.processingCredits ? "italic" : "normal" }}>{state.userData.processingCredits ? "Processing" : state.userData.credits}</Typography>}
              </IconButton>}
            {isOwner && storyRoute ?
              <IconButton onClick={(e) => { e.preventDefault(); e.stopPropagation(); setShowProjectCredits(true); }} title="Project Credits" className="credits" sx={{ display: 'flex', padding: "0 !important", marginTop: "5px", alignItems: "center", '&:hover': { cursor: 'pointer', background: "none !important" }, "&:hover span": { textDecoration: "underline" } }}>
                <Savings sx={{ color: "#ffffff", marginRight: "10px" }} />
                {!smallScreen && <Typography variant="span" sx={{ color: "#ffffff", fontSize: "14px" }}>{state.stories.activeStoryCredits ? state.stories.activeStoryCredits : "Fund this project"}</Typography>}
              </IconButton>
              : !isOwner && storyRoute && state.stories.activeStoryCredits > 0 ?
                <Tooltip title={`Project Credits: ${state.stories.activeStoryCredits}`} arrow>
                  <Box sx={{ display: 'flex', alignItems: "center", marginTop: "5px", padding: "0", cursor: 'default' }}>
                    <Savings sx={{ color: "#ffffff", marginRight: "10px" }} />
                    {!smallScreen && <Typography variant="span" sx={{ color: "#ffffff", fontSize: "14px" }}>{state.stories.activeStoryCredits}</Typography>}
                  </Box>
                </Tooltip>
                : <></>}
          </Box>}
          <Link
            sx={{ textAlign: logoAlign }}
            onClick={(e) => {
              navigate(e.target.parentNode.getAttribute("href")); e.preventDefault();
            }}
            href="/storyboards"
            className="logo"
          >
            <img src={smallScreen ? logoMobile : logo} />
          </Link>
          <Box sx={{ textAlign: "right" }}>
            <Box sx={{ display: "flex", justifyContent: "end", alignItems: "center", position: "relative" }}>
              <Box sx={{ display: "flex", justifyContent: "space-between", marginLeft: "15px" }}>
                {!isDeleted && story.isCompetition && showTimer && <Box sx={{ display: "flex", justifyContent: "center" }}><Box sx={timerStyles}>{timerDisplay}</Box></Box>}
                <Box sx={{ display: "inline-flex", gap: state.app.isMobileSize ? 1.5 : 3, justifyContent: "right !important" }}>
                  {(state.app.userIsStoryOwner || state.app.settings.communityCanStarred) && !isDeleted && starredActive && (
                    <IconButton onClick={handleToggleStar}>
                      {isStarred ? (
                        <Star sx={{ color: '#fff' }} />
                      ) : (
                        <StarOutline sx={{ color: '#fff' }} />
                      )}
                    </IconButton>
                  )}
                  {(state.app.userIsStoryOwner || state.app.settings.communityCanForkWithMedia) && !isDeleted && forkActive && <ForkProject />}
                  {(state.app.userIsStoryOwner || state.app.settings.communityCanShare) && !isDeleted && shareActive && (
                    <IconButton
                      onClick={(e) => {
                        setShowShare(true);
                      }}
                    >
                      <Share sx={{ color: "#ffffff" }} />
                    </IconButton>
                  )}
                  <Tooltip title={themeMode === 'dark' ? "Switch to Light Mode" : "Switch to Dark Mode"}>
                    <IconButton
                      onClick={toggleThemeMode}
                      aria-label="Toggle theme"
                    >
                      {themeMode === 'dark' ? (
                        <LightMode sx={{ color: "#ffffff" }} />
                      ) : (
                        <DarkMode sx={{ color: "#ffffff" }} />
                      )}
                    </IconButton>
                  </Tooltip>
                </Box>
              </Box>
              <Box sx={{ marginLeft: !smallScreen ? "15px" : "0", flexGrow: "0 !important" }}>
                {Object.keys(state.userData).length > 0 ? <IconButton onClick={(e) => { open_sidebar(); e.stopPropagation(); }} className="account" sx={{ textDecoration: "none", cursor: "pointer" }}>
                  {currentUser && <Box component="img" src={currentUser.photoURL} sx={{ borderRadius: "50%", display: "block" }} width="46px" height="46px" />}
                </IconButton> : <Link href="#" onClick={() => { sessionStorage.setItem('afterLoginRedirect', location.pathname + location.search); navigate("/login"); }} sx={{ color: "white" }} className="account">Login</Link>}
              </Box>
            </Box>
          </Box>
        </Box>

        {
          isDeleted ?
            null
            : <>
              <Box vertical="true" sx={{ ...subnavStyles, overflow: 'hidden' }}

                className={!breadcrumbs && filmed == undefined ? "title-head" : ""}>
                {(!shotId || (!state.app.userIsStoryOwner && !isAtLeastMember(userRole))) && (
                  <>
                    <Box className={`title ${title.length > 32 ? 'long' : ''}`} sx={{ flexGrow: medScreen ? "0 !important" : "1 !important" }}>
                      {isAtLeastMember(userRole) && !medScreen && editableTitle && (
                        <Typography variant="h1">
                          <EditableField init={title} setter={setStoryTitle} textClassName="input input__cd title_cd" num_rows={1} max_length={45} />
                        </Typography>
                      )}

                      {(!isAtLeastMember(userRole) || !editableTitle) && (
                        <Typography variant="h1" sx={{ maxWidth: (state.app.isMobileSize || location.pathname.indexOf('/attr')) ? "100%" : "33.3%" }}>
                          {title}
                        </Typography>
                      )}
                    </Box>
                    {text && (
                      <Typography variant="body2" className="text">
                        {text}
                      </Typography>
                    )}
                  </>
                )}
                {shotId && (state.app.userIsStoryOwner || isAtLeastMember(userRole)) && (
                  <>
                    <Box className="title">
                      <EditableField init={title} setter={setShotTitle} textClassName="input input__cd title_cd" num_rows={1} max_length={32} />
                    </Box>
                    {text !== undefined &&
                      <Box className="desc">
                        <EditableField init={text} setter={setShotDescription} textClassName="input input__cd text" num_rows={2} max_length={250} />
                      </Box>}
                  </>
                )}
                {!isDeleted && breadcrumbs && (
                  <Breadcrumbs owner={state.app.userIsStoryOwner} admin={isAdmin ? true : false} />
                )
                }
                {!isDeleted && !breadcrumbs && (
                  <Box sx={{ width: "calc(100% / 3)" }}></Box>
                )}
                {!isDeleted && filmed && (
                  <Box sx={{ textAlign: "right", width: "calc(100% / 3)" }} className="filmed">
                    {filmed}
                  </Box>
                )}
                {btns && (
                  <Box sx={{ display: "flex", justifyContent: "flex-end", width: "calc(100% / 3)" }}>
                    {btns}
                  </Box>
                )}
                {close && (
                  <Link onClick={close} sx={closeStyles} className="close">
                    <Close />
                  </Link>
                )}
                {breadcrumbs && !close && !filmed && !btns && <Box variant="div" className="empty" sx={{ width: "calc(100% / 3)" }}></Box>}
              </Box>
            </>
        }
      </Box>
      {sidebarVisible && <>
        <Box onClick={close_sidebar} sx={{ position: "absolute", width: "100vw", height: "100vh", zIndex: "1000", top: 0, left: 0 }}></Box>
        {verticalSidebar}
      </>}
      {importDialog}
      {!isLoggedIn && <LoginDialog
        open={loginOpen}
        title="Star Project"
        onClose={handleClose}
        authFunc={handleToggleStar}
        redirect={location.pathname}
        value="Log in to star this storyboard."
      />}
      {showShare && <ShareDialog open={showShare} toggleShare={toggleShare} />}
      {showAudio && <StoryAudio showAudio={showAudio} toggleShowAudio={toggleShowAudio} />}
      {showProjectCredits && <ProjectCreditsDialog
        open={showProjectCredits}
        onClose={() => setShowProjectCredits(false)}
        storyRef={state.stories.activeStoryRef}
        portalId={state.app.portal?.id || state.stories.activeStory?.portal_id}
      />}
      {showManageMembers && <ManageMembersDialog
        open={showManageMembers}
        onClose={() => setShowManageMembers(false)}
      />}
    </>
  );
};

export default Headbar;